<script lang="ts">
    import FaGithub from '~icons/fa-brands/github'
    import FaRegCopyright from '~icons/fa-regular/copyright'
    import Icon from './Icon.svelte'
    import { toast } from '#stores/toastStore.ts'
    import { page } from '$app/state'
    import RgbLine from '#cmp/shared/misc/RgbLine.svelte'
    import FaDonate from '~icons/fa-solid/heart'
    import { resolve } from '$app/paths'
    import { tooltip } from '#cmp/shared/floating/tooltip.svelte.ts'
    interface Props {
        pages?: RegExp[]
    }

    let { pages = [] }: Props = $props()
</script>

{#if pages.some((p) => page.url.pathname.match(p))}
    <footer class="footer">
        <div class="footer-inner">
            <RgbLine animated />
            <div class="footer-justify">
                <a
                    class="logo-wrapper"
                    href="https://specy.app"
                    {@attach tooltip('View my other websites')}
                >
                    <div class="logo-content">
                        <img src="/images/logo.png" alt="logo" class="logo" />
                        <div>Specy</div>
                    </div>
                </a>
                <a href={resolve('/changelog')}> Changelog </a>
                <div class="icon-wrapper">
                    <a
                        class="icon"
                        href={resolve('/donate')}
                        {@attach tooltip('Donate and support me')}
                        aria-label="Donate"
                    >
                        <Icon size={1.6}>
                            <FaDonate />
                        </Icon>
                    </a>
                    <div class="icon">
                        <Icon
                            size={1.6}
                            onClick={() => {
                                toast.custom(
                                    'Copyright',
                                    `© ${new Date().getFullYear()} Specy. All rights reserved.`,
                                    4000
                                )
                            }}
                        >
                            <FaRegCopyright />
                        </Icon>
                    </div>
                    <a
                        class="icon"
                        href="https://github.com/Specy/asm-editor"
                        target="_blank"
                        rel="noreferrer"
                        {@attach tooltip('Visit on github')}
                        aria-label="GitHub"
                    >
                        <Icon size={1.6}>
                            <FaGithub />
                        </Icon>
                    </a>
                </div>
            </div>
        </div>
    </footer>
{/if}

<style lang="scss">
    .logo-content {
        display: flex;
        align-items: center;
        > .logo {
            width: 2rem;
            height: 2rem;
            margin-right: 0.5rem;
        }
        > div {
            font-size: 1rem;
        }
    }
    a {
        color: var(--primary-text);
        transition: all 0.2s ease-in-out;
    }
    a:hover {
        color: var(--accent);
    }

    .icon-wrapper {
        display: flex;
        flex-direction: row;
        align-items: center;
        > .icon {
            display: flex;
            align-items: center;
            color: var(--primary-text);
            margin-left: 1rem;
            cursor: pointer;
            transition: all 0.3s;
            &:hover {
                transform: rotate(25deg) scale(1.1);
            }
        }
    }
    .footer {
        margin-top: auto;
        width: 100%;
    }

    .footer-justify {
        display: flex;
        margin-top: 1rem;

        justify-content: space-between;
        align-items: center;
    }
    .footer-inner {
        background-color: var(--primary);
        color: var(--primary-text);
        justify-content: center;
        padding: 1rem 1.5rem;
        display: flex;
        z-index: 2;
        flex-direction: column;
    }
    @media (max-width: 480px) {
        .footer-justify {
            flex-wrap: wrap;
            gap: 0.5rem;
        }
        .footer-inner {
            padding: 1rem;
            padding-top: 2rem;
            height: unset;
        }
        .logo-content {
            > .logo {
                width: 2rem;
                height: 2rem;
            }
        }
    }
</style>
